class MainFAQs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.filters = this.querySelectorAll('[data-filter]');
    this.categories = this.querySelectorAll('[data-category]');
    this.currentCategory = '';
    this.searchTerm = '';
    this.searchInput = this.querySelector('[data-search]');

    this.filters.forEach((filter) =>
      filter.addEventListener('click', this.handleOnFilterClick.bind(this)),
    );
    this.searchInput.addEventListener(
      'keyup',
      this.handleOnSearchInputChange.bind(this),
    );
  }

  handleOnFilterClick(event) {
    const value = event.target.dataset.value;

    if (value === 'all') return this.resetFilters(event);

    this.resetSearch();
    this.setActiveCategories(value);
    this.setActiveFilter(event);
  }

  resetFilters(event) {
    this.categories.forEach((category) => category.classList.remove('hidden'));
    this.setActiveFilter(event);
  }

  setActiveFilter(event) {
    this.filters.forEach((filter) => {
      const condition = event
        ? event.target === filter
        : filter === this.filters[0];

      return filter.classList.toggle('is-active', condition);
    });
  }

  setActiveCategories(value, categories) {
    if (categories) {
      return this.categories.forEach((category) =>
        category.classList.toggle('hidden', !categories.includes(category)),
      );
    }

    this.categories.forEach((category) =>
      category.classList.toggle('hidden', value !== category.dataset.category),
    );
  }

  resetSearch() {
    this.searchTerm = '';
    this.searchInput.value = '';
  }

  handleOnSearchInputChange(event) {
    this.searchTerm = event.target.value?.toLowerCase();
    this.resetFilters();
    this.setActiveCategories(null, this.searchTopics);
  }

  get searchTopics() {
    return Array.from(this.categories).filter((category) => {
      const title = category
        .querySelector('[data-title]')
        ?.textContent?.toLowerCase();
      const content = category
        .querySelector('[data-content]')
        ?.textContent?.toLowerCase();

      return (
        title.includes(this.searchTerm) || content.includes(this.searchTerm)
      );
    });
  }
}

customElements.define('main-faqs', MainFAQs);
